import React from 'react';
import PropTypes from 'prop-types';
import PaymentMethods from './payment_methods/PaymentMethods';
import CheckoutButton from './checkout_button/CheckoutButton';
import styles from './Footer.module.sass';

function Footer(props) {
  const { showOnlyCreditCard } = props;

  return (
    <div className={styles.footer}>
      <div className={styles.title}>
        100% FREE Samples & Returns
      </div>
      <CheckoutButton />
      <PaymentMethods showOnlyCreditCard={showOnlyCreditCard} />
    </div>
  );
}

Footer.propTypes = {
  showOnlyCreditCard: PropTypes.bool.isRequired,
};

export default Footer;
